<div class="d-flex justify-content-center text-center">
  <div><h3>Redirecionando...</h3></div>
</div>

<div class="d-flex justify-content-center text-center">
  <div class="br-loading medium"></div>
</div>

<div class="d-flex justify-content-center text-center px-3">
  <app-institutional-signature variant="light" layout="footer" />
</div>
